import config from '../../i18next-config';

export const { defaultLocale } = config.i18n;
